import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography, BlueskyMap, Gauge, useResponsive } from '@otcmarketsgroup/otcm-ui-lib';
import Loading from '../Loading';
import styles from './BlueSkyComplianceMap.module.scss';

const BlueSkyComplianceMap = ({ className, accent, data, loaded, blueskyScorePercent }) => {
    const mapContainerRef = useRef(null);
    const [fontSize, setFontSize] = useState(40);
    const { isTablet, isMedium, isLarge } = useResponsive();

    const gaugeContainerStyles = {
        position: 'absolute',
        bottom: "10%",
        right: 0,
        width: "25%",
        height: "25%",
        minWidth: "70px",
        minHeight: "70px",
    };

    let gaugeTextSize = 14;
    
    if (!isLarge && (isTablet || isMedium)) {
        gaugeTextSize = 24;
    } else if (isLarge) {
        gaugeTextSize = 36;
    }
    
    useEffect(() => {
        const updateFontSize = () => {
            if (mapContainerRef.current) {
                const width = mapContainerRef.current.offsetWidth;
                setFontSize(Math.max(12, Math.min(width * 0.035, 40)));
            }
        };

        updateFontSize();

        let resizeObserver = null;
        if (mapContainerRef.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(updateFontSize);
            resizeObserver.observe(mapContainerRef.current);
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, []);

    return (
        <div className={`${className}`}>
            <div className={styles.titleSection}>
                <Typography gutterBottom variant='h4'>
                    Blue Sky Compliance Map
                </Typography>
            </div>
            <Divider size='large' color='green' />
            <Loading loaded={loaded} data={data}>
                <div ref={mapContainerRef} className={blueskyScorePercent ? styles.mapContainer : ''}>
                    <BlueskyMap className={styles.map} accent={accent} data={data} />
                    {blueskyScorePercent && <Box sx={gaugeContainerStyles}>
                        <Gauge
                            referenceArcColor="var(--otc-light-gray)"
                            innerRadius="85%"
                            value={blueskyScorePercent}
                            valueMax={100}
                            textSize={gaugeTextSize}
                            valueText={(value) => `${value ?? 0}%`}
                        />
                    </Box>}
                </div>
            </Loading>
        </div>
    );
};

BlueSkyComplianceMap.defaultProps = {
    accent: 'green',
};

BlueSkyComplianceMap.propTypes = {
    className: PropTypes.string,
    accent: PropTypes.string,
    data: PropTypes.array,
    loaded: PropTypes.bool,
    blueskyScorePercent: PropTypes.string
};

export default BlueSkyComplianceMap;